import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, createElementVNode, normalizeStyle, createBlock, createCommentVNode, Fragment, renderList, mergeProps, withCtx, toDisplayString, createTextVNode } from 'vue';
import _sfc_main$4 from './basler-components.es83.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es104.js';
/* empty css                        */
import _sfc_main$1 from './basler-components.es7.js';
/* empty css                      */
import _sfc_main$3 from './basler-components.es177.js';
/* empty css                        */

const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "cta-teaser-section__foreground" };
const _hoisted_3 = { class: "cta-teaser-section__content" };
const _hoisted_4 = {
  key: 0,
  class: "cta-teaser-section__header"
};
const _hoisted_5 = { class: "cta-teaser-section__headlines" };
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 1,
  class: "cta-teaser-section__ctas"
};
const _hoisted_8 = {
  key: 0,
  class: "cta-teaser-section__ctas-image-placeholder"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CtaTeaserSection",
  props: {
    id: {},
    colorMode: { default: "dark" },
    headlines: {},
    texts: { default: () => [] },
    buttonLinks: {},
    backgroundType: { default: "animation" },
    bgColor01: { default: "#001643" },
    bgColor02: {},
    bgGradientDeg: {},
    backgroundMedia: { default: null },
    image: {},
    alignCtasWithImage: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const background = computed(() => {
      let background2 = props.bgColor01;
      if (props.backgroundType === "color" && props.bgColor02) {
        const deg = props.bgGradientDeg || "180";
        background2 = `linear-gradient(${deg}deg, ${props.bgColor01}, ${props.bgColor02});`;
      }
      return background2;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: _ctx.id,
        class: normalizeClass([
          "cta-teaser-section",
          {
            "theme-light": _ctx.colorMode === "light",
            "theme-dark": _ctx.colorMode === "dark" || _ctx.colorMode === "dark-purple",
            "align-ctas-with-image": _ctx.alignCtasWithImage
          }
        ])
      }, [
        createElementVNode("div", {
          class: "cta-teaser-section__background",
          style: normalizeStyle(`--bg-color: ${background.value}`)
        }, [
          _ctx.backgroundType === "animation" ? (openBlock(), createBlock(_sfc_main$1, {
            key: 0,
            "color-mode": _ctx.colorMode
          }, null, 8, ["color-mode"])) : createCommentVNode("", true),
          _ctx.backgroundType === "image" ? (openBlock(), createBlock(_sfc_main$2, {
            key: 1,
            media: _ctx.backgroundMedia,
            class: "cta-teaser-section__background-media"
          }, null, 8, ["media"])) : createCommentVNode("", true)
        ], 4),
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            _ctx.headlines ? (openBlock(), createElementBlock("div", _hoisted_4, [
              _ctx.image ? (openBlock(), createBlock(_sfc_main$2, {
                key: 0,
                media: _ctx.image,
                class: "cta-teaser-section__image"
              }, null, 8, ["media"])) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_5, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.headlines, (headline) => {
                  return openBlock(), createBlock(_sfc_main$3, mergeProps({
                    key: headline.content,
                    ref_for: true
                  }, { ...headline, slotContent: void 0 }), {
                    default: withCtx(() => [
                      createElementVNode("span", {
                        innerHTML: headline.content
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1040);
                }), 128))
              ])
            ])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.texts, (text) => {
              return openBlock(), createElementBlock("p", {
                key: text,
                class: "cta-teaser-section__text"
              }, toDisplayString(text), 1);
            }), 128)),
            _ctx.buttonLinks ? (openBlock(), createElementBlock("div", _hoisted_7, [
              _ctx.image && _ctx.alignCtasWithImage ? (openBlock(), createElementBlock("div", _hoisted_8)) : createCommentVNode("", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.buttonLinks, (buttonLink) => {
                return openBlock(), createBlock(_sfc_main$4, mergeProps({
                  key: buttonLink.text,
                  ref_for: true
                }, buttonLink.link), {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(buttonLink.text), 1)
                  ]),
                  _: 2
                }, 1040);
              }), 128))
            ])) : createCommentVNode("", true)
          ])
        ])
      ], 10, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
